<template>
  <div
    class="custom-tooltip"
    @mouseenter="showTooltip"
    @mousemove="updatePosition"
    @mouseleave="hideTooltip"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    content: String,
    fontSize: { type: Number, default: 14 },
    bgColor: { type: String, default: "rgba(51, 51, 51, 0.8)" },
    textColor: { type: String, default: "#fff" },
  },
  data() {
    return {
      position: { x: 0, y: 0 },
    };
  },
  methods: {
    showTooltip() {
        const targetEle = document.querySelector(".dynamic-title-tooltip-content");
        if(targetEle) {
            targetEle.innerHTML = this.content;
            targetEle.style.display = 'block';
            return;
        }
        const newEle = document.createElement('div');
        newEle.className = 'dynamic-title-tooltip-content';
        newEle.style = `
        position: fixed;
        padding: 6px 12px;
        border-radius:4px;
        point-events: none;
        z-index:9999;
        max-width:200px;
        word-wrap: break-word;
        left:${this.position.x}px;
        top: ${this.position.y}px;
        font-size:${this.fontSize}px;
        background-color: ${this.bgColor};
        color: ${this.textColor};
        `
        newEle.innerHTML = this.content;
        document.body.appendChild(newEle);
    },
    hideTooltip() {
        const targetEle =document.querySelector(".dynamic-title-tooltip-content");
        if(targetEle) {
            targetEle.style.display = 'none';
            targetEle.innerHTML = '';
        }
    },
    updatePosition(e) {
      const offset = 10; // 距离鼠标的偏移
      this.position.x = e.clientX + offset;
      this.position.y = e.clientY + offset;

      // 防止超出屏幕
      const tooltip = document.querySelector(".dynamic-title-tooltip-content");
      if (tooltip) {
        const tooltipRect = tooltip.getBoundingClientRect();
        const windowWidth = window.innerWidth;
        const windowHeight = window.innerHeight;

        if (this.position.x + tooltipRect.width > windowWidth) {
          this.position.x = windowWidth - tooltipRect.width - 5;
        }
        if (this.position.y + tooltipRect.height > windowHeight) {
          this.position.y = windowHeight - tooltipRect.height - 5;
        }

        tooltip.style.left = `${this.position.x}px`;
        tooltip.style.top = `${this.position.y}px`;
      }
    },
  },
};
</script>

<style scoped>
.custom-tooltip {
  display: inline-block;
  position: relative;
}

/* .dynamic-title-tooltip-content {
  position: fixed;
  padding: 6px 12px;
  border-radius: 4px;
  pointer-events: none;
  z-index: 9999;
  max-width: 200px;
  word-wrap: break-word;
  opacity: 1;
  transition: opacity 0.2s;
}

.custom-tooltip:hover .tooltip-content {
  opacity: 1;
} */
</style>